interface DigitProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const Digit = ({ width = 38, height = 13, className = '' }: DigitProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 38 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={`inline-block ${className}`}
  >
    <path d='M10 13.0001V9.9104H37.869V13.0001H10Z' fill='#4444FF' />
  </svg>
);

export default Digit;
